import { Badge } from '@/components/ui/Badge'
import { Card } from '@/components/ui/Card'
import { EXPERIMENTS } from '@/content/experiments'
import { useI18n } from '@/i18n'

export function ExperimentList() {
  const { t, pick } = useI18n()

  return (
    <ul className="grid gap-4 md:grid-cols-2">
      {EXPERIMENTS.map((experiment) => (
        <li key={experiment.slug} className="h-full">
          <Card interactive className="flex h-full flex-col">
            <div className="flex flex-wrap items-center gap-2">
              <Badge tone="gold">{t.science.difficultyLevels[experiment.difficulty]}</Badge>
              {experiment.protocolStatus === 'draft' ? (
                <Badge>{t.science.protocolHeading} · {t.common.comingSoon}</Badge>
              ) : null}
            </div>

            <h3 className="mt-4 text-xl text-parchment">{pick(experiment.title)}</h3>
            <p className="mt-2.5 flex-1 text-sm text-muted">{pick(experiment.summary)}</p>

            <div className="mt-5 border-t border-line/70 pt-4">
              <p className="eyebrow mb-3">{t.science.equipment}</p>
              <ul className="flex flex-wrap gap-2">
                {pick(experiment.equipment).map((item) => (
                  <li
                    key={item}
                    className="rounded-full border border-line px-3 py-1 text-xs text-muted"
                  >
                    {item}
                  </li>
                ))}
              </ul>
            </div>
          </Card>
        </li>
      ))}
    </ul>
  )
}
